module.exports = __webpack_public_path__ + "static/img/store-notification-icon.60d2bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store-notification-icon.png
// module id = +7XD
// module chunks = 18